/**
 * Generated by orval 🍺
 * Do not edit manually.
 * clarityrcm.api
 * OpenAPI spec version: 1.0
 */
import type {
  CaptureSessionResponse,
  CcofCaptureConfirmRequest,
  CreateCaptureSessionRequest,
  PaymentMethodResponse,
} from "../../../../../lib/api-types/schemas";

import { authenticatedClient } from "../../authenticatedClient";

export type postApiPracticesPracticeIdPatientsPatientIdCaptureSessionsResponse201 =
  {
    data: CaptureSessionResponse;
    status: 201;
  };

export type postApiPracticesPracticeIdPatientsPatientIdCaptureSessionsResponse400 =
  {
    data: void;
    status: 400;
  };

export type postApiPracticesPracticeIdPatientsPatientIdCaptureSessionsResponse401 =
  {
    data: void;
    status: 401;
  };

export type postApiPracticesPracticeIdPatientsPatientIdCaptureSessionsResponse403 =
  {
    data: void;
    status: 403;
  };

export type postApiPracticesPracticeIdPatientsPatientIdCaptureSessionsResponse404 =
  {
    data: void;
    status: 404;
  };

export type postApiPracticesPracticeIdPatientsPatientIdCaptureSessionsResponse409 =
  {
    data: void;
    status: 409;
  };

export type postApiPracticesPracticeIdPatientsPatientIdCaptureSessionsResponse422 =
  {
    data: void;
    status: 422;
  };

export type postApiPracticesPracticeIdPatientsPatientIdCaptureSessionsResponseSuccess =
  postApiPracticesPracticeIdPatientsPatientIdCaptureSessionsResponse201 & {
    headers: Headers;
  };
export type postApiPracticesPracticeIdPatientsPatientIdCaptureSessionsResponseError =
  (
    | postApiPracticesPracticeIdPatientsPatientIdCaptureSessionsResponse400
    | postApiPracticesPracticeIdPatientsPatientIdCaptureSessionsResponse401
    | postApiPracticesPracticeIdPatientsPatientIdCaptureSessionsResponse403
    | postApiPracticesPracticeIdPatientsPatientIdCaptureSessionsResponse404
    | postApiPracticesPracticeIdPatientsPatientIdCaptureSessionsResponse409
    | postApiPracticesPracticeIdPatientsPatientIdCaptureSessionsResponse422
  ) & {
    headers: Headers;
  };

export const getPostApiPracticesPracticeIdPatientsPatientIdCaptureSessionsUrl =
  (practiceId: string, patientId: string) => {
    return `/api/practices/${practiceId}/patients/${patientId}/capture-sessions`;
  };

/**
 * **Actor types:** `clinic`, `internal`
 *
 * **Practice-scoped:** route `{practiceId}` must match the user's `practiceId` claims
 *
 * Channel 'staff' starts an in-person capture and returns the credentials to collect the card immediately. Channel 'link' sends the patient a one-time link to save their card themselves; the credentials are resolved by the patient from the link.
 * @summary Creates a card-on-file capture session for a patient via the staff or link channel.
 */
export const postApiPracticesPracticeIdPatientsPatientIdCaptureSessions =
  async (
    practiceId: string,
    patientId: string,
    createCaptureSessionRequest?: CreateCaptureSessionRequest,
    options?: Parameters<typeof authenticatedClient>[1],
  ): Promise<postApiPracticesPracticeIdPatientsPatientIdCaptureSessionsResponseSuccess> => {
    const getHeaders = (
      h?: NonNullable<RequestInit["headers"]>,
    ): Record<string, string | readonly string[]> => {
      if (!h) return {};
      if (h instanceof Headers) return Object.fromEntries(h.entries());
      if (Array.isArray(h)) return Object.fromEntries(h);
      return h;
    };
    return authenticatedClient<postApiPracticesPracticeIdPatientsPatientIdCaptureSessionsResponseSuccess>(
      getPostApiPracticesPracticeIdPatientsPatientIdCaptureSessionsUrl(
        practiceId,
        patientId,
      ),
      {
        ...options,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...getHeaders(options?.headers),
        },
        body: JSON.stringify(createCaptureSessionRequest),
      },
    );
  };

export type postApiPracticesPracticeIdCaptureSessionsConfirmResponse200 = {
  data: PaymentMethodResponse;
  status: 200;
};

export type postApiPracticesPracticeIdCaptureSessionsConfirmResponse202 = {
  data: void;
  status: 202;
};

export type postApiPracticesPracticeIdCaptureSessionsConfirmResponse401 = {
  data: void;
  status: 401;
};

export type postApiPracticesPracticeIdCaptureSessionsConfirmResponse403 = {
  data: void;
  status: 403;
};

export type postApiPracticesPracticeIdCaptureSessionsConfirmResponse404 = {
  data: void;
  status: 404;
};

export type postApiPracticesPracticeIdCaptureSessionsConfirmResponse502 = {
  data: void;
  status: 502;
};

export type postApiPracticesPracticeIdCaptureSessionsConfirmResponseSuccess = (
  | postApiPracticesPracticeIdCaptureSessionsConfirmResponse200
  | postApiPracticesPracticeIdCaptureSessionsConfirmResponse202
) & {
  headers: Headers;
};
export type postApiPracticesPracticeIdCaptureSessionsConfirmResponseError = (
  | postApiPracticesPracticeIdCaptureSessionsConfirmResponse401
  | postApiPracticesPracticeIdCaptureSessionsConfirmResponse403
  | postApiPracticesPracticeIdCaptureSessionsConfirmResponse404
  | postApiPracticesPracticeIdCaptureSessionsConfirmResponse502
) & {
  headers: Headers;
};

export const getPostApiPracticesPracticeIdCaptureSessionsConfirmUrl = (
  practiceId: string,
) => {
  return `/api/practices/${practiceId}/capture-sessions/confirm`;
};

/**
 * **Actor types:** `clinic`, `internal`
 *
 * **Practice-scoped:** route `{practiceId}` must match the user's `practiceId` claims
 *
 * Identifies the capture by the payment-setup reference retained on the redirected page and reads the card details directly so the staff UI renders the saved card immediately. On 202 (not yet settled) or 502 (provider unreachable) the client falls back to polling patient details.
 * @summary Confirms a staff-assisted card capture immediately after the payment redirect.
 */
export const postApiPracticesPracticeIdCaptureSessionsConfirm = async (
  practiceId: string,
  ccofCaptureConfirmRequest?: CcofCaptureConfirmRequest,
  options?: Parameters<typeof authenticatedClient>[1],
): Promise<postApiPracticesPracticeIdCaptureSessionsConfirmResponseSuccess> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return authenticatedClient<postApiPracticesPracticeIdCaptureSessionsConfirmResponseSuccess>(
    getPostApiPracticesPracticeIdCaptureSessionsConfirmUrl(practiceId),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(ccofCaptureConfirmRequest),
    },
  );
};
